import { render, staticRenderFns } from "./catalog-item-img.vue?vue&type=template&id=a9ff8ad8"
import script from "./catalog-item-img.vue?vue&type=script&lang=js"
export * from "./catalog-item-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports